define(["exports", "./pubsubhub"], function (_exports, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.name = void 0;
  // @ts-check

  /**
   * This Module adds a `respecIsReady` property to the document object.
   * The property returns a promise that settles when ReSpec finishes
   * processing the document.
   */
  const name = "core/respec-ready";
  /** @type {Promise<void>} */

  _exports.name = name;
  const respecDonePromise = new Promise(resolve => {
    (0, _pubsubhub.sub)("end-all", resolve, {
      once: true
    });
  });
  Object.defineProperty(document, "respecIsReady", {
    get() {
      return respecDonePromise;
    }

  });
});
//# sourceMappingURL=respec-ready.js.map